import React from 'react';

import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Flex, Space, Tag, Typography } from 'antd';

const { Text } = Typography;

interface ShipmentHeaderProps {
  lpui: string;
  carrierTrackingCode: string;
  inspectionInProgress?: boolean;
  isCollapsible?: boolean;
  isExpanded?: boolean;
  onToggle?: () => void;
  isDisabled?: boolean;
}

/**
 * Reusable header component for shipment cards.
 * Displays LPUI, carrier reference number, and optional collapse button.
 */
export const ShipmentHeader = ({
  lpui,
  carrierTrackingCode,
  inspectionInProgress = false,
  isCollapsible = false,
  isExpanded = false,
  onToggle,
  isDisabled = false,
}: ShipmentHeaderProps) => (
  <>
    <Flex justify="space-between" align="flex-start">
      <Space direction="vertical" size="small">
        {inspectionInProgress && <Tag color="red">In inspection</Tag>}
        <Text
          style={{
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '125%',
          }}
        >
          LPUI
        </Text>
      </Space>
      {isCollapsible && onToggle && (
        <Button
          onClick={onToggle}
          type="text"
          style={{ width: '.9375rem', height: '.9375rem' }}
          disabled={isDisabled}
        >
          {isExpanded ? <UpOutlined /> : <DownOutlined />}
        </Button>
      )}
    </Flex>
    <Space
      direction="vertical"
      size={2}
      style={{ width: '100%', overflow: 'hidden' }}
    >
      <Text
        style={{
          fontSize: 'clamp(0.875rem, 2vw, 1rem)',
          fontWeight: 400,
          lineHeight: '135%',
          color: '#33645B',
          maxWidth: '100%',
          wordBreak: 'break-all',
        }}
      >
        {lpui}
      </Text>
      <Text
        style={{
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '125%',
        }}
      >
        Carrier reference number
      </Text>
      <Text
        style={{
          fontSize: 'clamp(14px, 2vw, 16px)',
          fontWeight: 500,
          lineHeight: '125%',
          color: '#33645B',
          maxWidth: '100%',
          wordBreak: 'break-all',
        }}
      >
        {carrierTrackingCode}
      </Text>
    </Space>
  </>
);
